import React, { Component } from 'react';

class Third extends Component {
  render() {
    return (
      <p className="Third-intro">
        Hello from <code>Third</code>.
      </p>
    );
  }
}

export default Third;



// WEBPACK FOOTER //
// ./src/components/Page/Third/Third.js